import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PayCancel() {
  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#FBF9F6]">
      <div className="nb-card p-10 max-w-md w-full text-center">
        <XCircle size={48} className="mx-auto text-rose-600"/>
        <h1 className="display text-2xl font-bold mt-4">Payment cancelled</h1>
        <p className="mt-2 text-slate-600">No charge was made.</p>
        <Link to="/student" className="nb-btn mt-6 inline-flex">Back to Dashboard</Link>
      </div>
    </div>
  );
}
